import { type ApolloError, gql, useLazyQuery } from '@apollo/client'
import { useCallback } from 'react'

import { useUserContext } from '@/contexts/UserContext.tsx'
import { SEARCH_STORIES_GQL_SCHEMA } from '@/requests/apollo/schema.ts'

export const useQuerySearch = (): {
  search: (filter: SearchFilter) => void
  loading: boolean
  error: ApolloError | undefined
  result:
    | {
        stories: Story[]
        totalHits: number
        totalHitsWithDone: number
        totalPoints: number
        totalPointsCompleted: number
      }
    | undefined
} => {
  const { apiKey } = useUserContext()

  const [execute, { loading, error, data }] = useLazyQuery(
    gql`query SearchStories($filter: StoryFilter!) {
      searchStories(filter: $filter) {
        ${SEARCH_STORIES_GQL_SCHEMA}
      }
    }`,
    {
      context: {
        headers: {
          'X-API-KEY': apiKey,
        },
      },
      fetchPolicy: 'network-only',
    },
  )

  const search = useCallback((filter: SearchFilter) => execute({ variables: { filter } }), [execute])

  return {
    search,
    loading,
    error,
    result: data?.searchStories,
  }
}
